import { useContext, useEffect, useState } from "react";
import { store } from "../../Store";
import { STORAGE_KEYS } from "../../../config/constants";

/**
 * Obtiene del localStorage el arreglo de usuarios que ya vieron el tutorial de crear perfil.
 * @returns {string[]} usuarios que ya vieron el tutorial
 */
const getStoredUsers = () => {
	try {
		const storedValue = window.localStorage.getItem(
			STORAGE_KEYS.personal_account_create_profile_tutorial_seen_users
		);
		const parsedValue = JSON.parse(storedValue);
		return Array.isArray(parsedValue) ? parsedValue : [];
	} catch (error) {
		return [];
	}
};

/**
 * Hook que gestiona el estado persistente del tutorial de crear perfil.
 * Usa el username global autenticado y lo almacena en localStorage
 * para evitar volver a mostrar el tutorial al mismo usuario.
 *
 * @returns {{seen:boolean, markSeen: function}} estado y función para marcar el tutorial como visto
 */
export const useCreateProfileTutorial = () => {
	const { state } = useContext(store);
	const username = state?.username;
	const [seen, setSeen] = useState(() => {
		const storedUsers = getStoredUsers();
		return Boolean(username) && storedUsers.includes(username);
	});

	useEffect(() => {
		const storedUsers = getStoredUsers();
		setSeen(Boolean(username) && storedUsers.includes(username));
	}, [username]);

	/**
	 * Marca el tutorial como visto para el usuario actual.
	 */
	const markSeen = () => {
		if (!username) return;
		const storedUsers = getStoredUsers();
		if (storedUsers.includes(username)) {
			setSeen(true);
			return;
		}

		const updatedUsers = [...storedUsers, username];
		window.localStorage.setItem(
			STORAGE_KEYS.personal_account_create_profile_tutorial_seen_users,
			JSON.stringify(updatedUsers)
		);
		setSeen(true);
	};

	return {
		seen,
		markSeen,
	};
};
